"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_DETAIL_PAGE = exports.COUPON_DETAIL_PAGE = exports.MAKE_ORDER_PAGE = void 0;
exports.MAKE_ORDER_PAGE = 'MAKE_ORDER_PAGE';
exports.COUPON_DETAIL_PAGE = 'COUPON_DETAIL_PAGE';
exports.ORDER_DETAIL_PAGE = 'ORDER_DETAIL_PAGE';
var MERCHANT_SETTLEMENT_PAGES = (_a = {},
    _a[exports.MAKE_ORDER_PAGE] = '/add-order',
    _a[exports.COUPON_DETAIL_PAGE] = '/detail',
    _a[exports.ORDER_DETAIL_PAGE] = '/order-detail',
    _a);
exports.default = MERCHANT_SETTLEMENT_PAGES;
